export const getError = ({ invalid, error }) => {
  const errorMessage = (invalid && error?.message) || undefined;
  return {
    errorMessage,
    hasError: !!invalid,
  };
};
